import Paperclip from '../../src/legacy/Paperclip';
export default Paperclip;
